export default __webpack_public_path__ + "3a82107fcfe41d19505a261449ea9f5e.svg";